
export default [
    {
        icon: 'home',
        text: 'base.home',
        link: { name: "home" },
        panel: false
    },
    {
        icon: 'mdi-package-variant',
        text: 'Planes',
        link: { name: "PlanManagementPage" },
        panel: false,
        permission: 'ADMIN_PLAN_SHOW'
    },
    {
        icon: 'business',
        text: 'admin.company.title',
        link: { name: "CompanyManagementPage" },
        panel: false,
        permission: 'ADMIN_COMPANY_SHOW'
    },
    {
        icon: 'warehouse',
        text: 'deposito.title',
        link: { name: "DepositoManagementPage" },
        panel: false,
        permission: 'DEPOSITO_SHOW',
    },
    {
        icon: 'people',
        text: 'admin.inviraUser.title',
        link: { name: "InviraUserManagementPage" },
        panel: false,
        permission: 'ADMIN_USER_SHOW'
    },
    {
        icon: 'verified_user',
        text: 'admin.inviraRole.title',
        link: { name: "InviraRolesManagementPage" },
        panel: false,
        permission: 'ADMIN_INVIRA_ROLE_SHOW'
    },
    {
        icon: 'mdi-account-cog',
        text: 'Permisos por usuario',
        link: { name: "UserPermissionsPage" },
        panel: false,
        permission: 'ADMIN_USER_PERMISSIONS_SHOW'
    },
    {
        icon: 'person',
        text: 'menu.administration',
        panel: false,
        permission: 'SECURITY_ADMIN_MENU',
        children: [
            {
                icon: 'assignment_ind',
                text: 'menu.userdashboard',
                link: { name: "userDashboard" },
                panel: false,
                permission: 'SECURITY_DASHBOARD_SHOW'
            },
            {
                icon: 'settings_applications',
                text: 'menu.customization',
                link: { name: "customization" },
                panel: false,
                permission: 'CUSTOMIZATION_SHOW'
            },
            {
                icon: 'assignment_ind',
                text: 'user.title',
                link: { name: "userManagement" },
                panel: false,
                permission: 'SECURITY_USER_SHOW'
            },
            {
                icon: 'verified_user',
                text: 'role.title',
                link: { name: "roleManagement" },
                panel: false,
                permission: 'SECURITY_ROLE_SHOW'
            },
            {
                icon: 'group',
                text: 'group.title',
                link: { name: "groupManagement" },
                panel: false,
                permission: 'SECURITY_GROUP_SHOW'
            },

        ]
    },
]

